import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-950 text-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 py-14">
          <div>
            <Link to="/" className="inline-block cursor-pointer">
              <span className="text-2xl font-heading text-background-50">吃瓜网</span>
              <span className="text-xs bg-primary-500 text-background-50 px-2 py-0.5 rounded-full ml-2 font-label">
                在线
              </span>
            </Link>
            <p className="mt-4 text-sm text-background-400 leading-relaxed">
              国内领先的娱乐八卦资讯聚合平台，每日更新最新网红塌房、明星八卦、黑料曝光等热门内容，是您在线吃瓜的第一选择。
            </p>
          </div>

          <div>
            <h4 className="text-xs font-label uppercase tracking-wider text-background-500 mb-4">
              快速链接
            </h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">
                首页
              </Link>
              <Link to="/category/wanghong-tafang" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">
                网红塌房
              </Link>
              <Link to="/category/heiliao-baoguang" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">
                黑料曝光
              </Link>
              <Link to="/about" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap">
                关于我们
              </Link>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-label uppercase tracking-wider text-background-500 mb-4">
              关注我们
            </h4>
            <div className="flex flex-col gap-2.5">
              <a href="#" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-weibo-line mr-2"></i>新浪微博
              </a>
              <a href="#" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-wechat-line mr-2"></i>微信公众号
              </a>
              <a href="#" className="text-sm text-background-300 hover:text-background-50 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-video-line mr-2"></i>抖音
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-label uppercase tracking-wider text-background-500 mb-4">
              联系我们
            </h4>
            <p className="text-sm text-background-300 mb-3">
              有猛料？欢迎爆料！我们严格保护您的隐私。
            </p>
            <a
              href="mailto:tips@chiguawang.com"
              className="inline-flex items-center gap-2 text-sm text-primary-400 hover:text-primary-300 transition-colors cursor-pointer whitespace-nowrap"
            >
              tips@chiguawang.com
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>

        <div className="border-t border-background-800/30 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 吃瓜网在线 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap">
              隐私政策
            </a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap">
              用户协议
            </a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap" rel="nofollow">
              免责声明
            </a>
          </div>
        </div>

        <div className="pb-8">
          <div className="text-[80px] md:text-[140px] font-heading font-bold text-background-800/20 leading-none tracking-tighter select-none overflow-hidden whitespace-nowrap">
            吃瓜网在线
          </div>
        </div>
      </div>
    </footer>
  );
}